module.exports = __webpack_public_path__ + "static/media/chapter-two-picnic.dd283a7e.png";